import { ApplicationConfig, LOCALE_ID, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService
} from '@azure/msal-angular';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { MSALGuardConfigFactory, MSALInstanceFactory, MSALInterceptorConfigFactory } from './config/msal/msal.config';
import { DATE_PIPE_DEFAULT_OPTIONS, DatePipe, IMAGE_CONFIG } from '@angular/common';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { dateFormat } from './models/date-formats';
import { CUSTOM_NGX_DATE_FORMATS } from './config/date-adapter/custom-date-formats';
import { provideNgxMatCustomDate } from './config/date-adapter/custom-ngx-date-adapter-provider';
import { IsNotMidnightPipe } from './pipes/is-not-midnight.pipe';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { xssInterceptor } from './utils/http-interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAnimations(),
    provideRouter(routes),
    provideMomentDateAdapter(CUSTOM_NGX_DATE_FORMATS),
    provideNgxMatCustomDate(),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: IMAGE_CONFIG,
      useValue: { disableImageSizeWarning: true }
    },
    { provide: LOCALE_ID, useValue: 'en-GB' },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: { duration: 6000, horizontalPosition: 'center', verticalPosition: 'top', panelClass: 'snackbar-red' }
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { maxWidth: 1280 } },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: DATE_PIPE_DEFAULT_OPTIONS, useValue: { dateFormat, timezone: 'UTC' } },
    { provide: MAT_SELECT_CONFIG, useValue: { overlayPanelClass: 'app-select-panel' } },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    DatePipe,
    IsNotMidnightPipe,
    provideHttpClient(withInterceptors([xssInterceptor]))
  ]
};
